module.exports = __webpack_public_path__ + "20ae6ec3a3f5d38882dc950de680c2ef.pdf";